import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    } else if (location.pathname !== '/') {
      // If we're not on the home page, navigate to home and then scroll
      navigate('/', { state: { scrollTo: sectionId } });
      setMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header>
      <div className="header-content">
        <div className="logo-container">
          <div className="logo-placeholder">
            <img src="/media/logo-kd-on-call.jpeg" alt="Kilo Delta Logo" />
          </div>

        </div>
        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
        <nav className={mobileMenuOpen ? 'mobile-menu-open' : ''}>
          <ul className="main-nav">
            <li>
              {location.pathname === '/' ? (
                  <button onClick={() => scrollToSection('home')}>Home</button>
              ) : (
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              )}
            </li>
            <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</Link></li>
            <li>
              <button onClick={() => scrollToSection('services')}>Our Services</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('donate')}>Support Us</button>
            </li>
            <li>
              <button onClick={() => scrollToSection('footer')}>Contact</button>
            </li>
            <li>
              <Link to="/donate" className="nav-donate" onClick={() => setMobileMenuOpen(false)}>Donate</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
